import React from "react";

import Picture from "../components/Navbar Components/Picture";
import NewAccountForm from "./NewAccountForm";

const NewAccountPage = () => {
  return (
    <>
      <Picture />
      <NewAccountForm />
    </>
  );
};
export default NewAccountPage;